'use client';
import { NavigationItemInterface } from '@/data/defaultValue';
import { FC } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import Link from 'next/link';
// import { ChevronDownIcon } from 'lucide-react';
import { ChevronDown } from 'lucide-react';
import { DrawerClose } from '@/components/ui/drawer';

interface MobileNavItem2Props {
  className?: string;
  menuItem: NavigationItemInterface;
}

const MobileNavItem: FC<MobileNavItem2Props> = ({ menuItem }) => {
  const isSubCategories =
    menuItem?.sub_categories && menuItem?.sub_categories.length > 0;

  const renderDropdownMenu = (menuDropdown: NavigationItemInterface) => {
    return (
      <Accordion type='single' collapsible>
        <AccordionItem value='item-1'>
          <AccordionTrigger>
            {menuDropdown?.href ? (
              <Link
                href={`/category${menuDropdown.href}`}
                className='cursor-pointer'
              >
                {menuDropdown.name}
              </Link>
            ) : (
              menuDropdown.name
            )}
            <ChevronDown className='h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200' />
          </AccordionTrigger>
          <AccordionContent>
            {menuDropdown.sub_categories!.map((i, index) => {
              const isChileDropdown = i?.sub_categories
                ? i?.sub_categories.length > 0
                : false;
              if (isChileDropdown) {
                return (
                  <div key={index}>{renderDropdownMenuNavlinkHasChild(i)}</div>
                );
              } else {
                return renderDropdownMenuNavlink(i);
              }
            })}
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    );
  };

  const renderDropdownMenuNavlink = (item: NavigationItemInterface) => {
    return (
      <div className='flex flex-1 items-center justify-between pt-2  text-sm  transition-all hover:underline text-left [&[data-state=open]>svg]:rotate-180 '>
        {item?.href ? (
          <DrawerClose asChild>
            <Link
              href={`/category${item.href}`}
              className='cursor-pointer  block w-full'
            >
              {item.name}
            </Link>
          </DrawerClose>
        ) : (
          item.name
        )}
      </div>
    );
  };

  const renderDropdownMenuNavlinkHasChild = (
    items: NavigationItemInterface,
  ) => {
    return (
      <Accordion type='single' collapsible>
        <AccordionItem value='item-1'>
          <AccordionTrigger>
            {items?.href ? (
              <Link href={`/category${items.href}`} className='cursor-pointer'>
                {items.name}
              </Link>
            ) : (
              items.name
            )}{' '}
            222
            <ChevronDown className='h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200' />
          </AccordionTrigger>
          <AccordionContent>
            {items?.sub_categories &&
              items.sub_categories.length > 0 &&
              items.sub_categories.map(i => {
                const hasChild =
                  i?.sub_categories && i.sub_categories.length > 0;
                if (hasChild) {
                  return renderDropdownMenuNavlinkHasChild(i);
                } else {
                  return renderDropdownMenuNavlink(i);
                }
              })}
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    );
  };

  const renderMainItem = (item: NavigationItemInterface) => {
    return (
      <Accordion type='single' collapsible>
        <AccordionItem value='item-1'>
          <AccordionTrigger>
            {item?.href ? (
              <Link
                href={`/category${item.href}`}
                className='cursor-pointer block w-full'
              >
                {item.name}
              </Link>
            ) : (
              item.name
            )}

            {isSubCategories && (
              <ChevronDown className='h-2 w-4 shrink-0 text-muted-foreground transition-transform duration-200' />
            )}
          </AccordionTrigger>
        </AccordionItem>
      </Accordion>
    );
  };

  if (isSubCategories) {
    return renderDropdownMenu(menuItem);
  } else {
    return renderMainItem(menuItem);
  }
};

export default MobileNavItem;
